<template>
    <Modal :value="show" :width="600" :mask-closable="false" @on-cancel="handleCancel" @on-visible-change="visableChange" class="inportAbcd">
        <h3 slot="header" class="clearfix">
            <span class="pull-left" style="line-height: 30px;font-size: 16px;">{{title}}</span>
        </h3>
        <div style="overflow: auto;margin:10px 0 30px 0">
           <div class="step-header">
                <div class="step-bar">
                    <div class="step-bar-active" id="step-bar-active"></div>
                </div>
                <ul>
                    <li class="active"><span></span>
                        <p>{{$t('gscInt.import.downTemp')}}</p><!--模版下载-->
                    </li>
                    <li v-if="current >= 1" class="active"><span></span>
                        <p>{{$t('gscInt.import.dataImport')}}</p><!--数据导入-->
                    </li>
                    <li v-else><span></span>
                        <p>{{$t('gscInt.import.dataImport')}}</p><!--数据导入-->
                    </li>
                    <li v-if="current >= 2" class="active"><span></span>
                        <p>{{$t('gscInt.import.resultConfirm')}}</p><!--结果确认-->
                    </li>
                    <li v-else><span></span>
                        <p>{{$t('gscInt.import.resultConfirm')}}</p><!--结果确认-->
                    </li>
                </ul>
            </div>

        </div>

        <div v-if="current === 0" class="step-container">
            <p class="form-item-tip" style="display: inline-block">{{$t('gscInt.import.tips1')}}</p><!--请下载数据导入模版，并按照模版格式填写需导入的数据-->
            <span @click="downloadTemplate()" style="color:#0077FF;margin-left: 20px;cursor:pointer">{{$t('gscInt.import.downTemp')}}</span><!--模版下载-->
            <slot name="templateContent"></slot>
        </div>
        <div v-else-if="current === 1" class="step-container">
            <Upload :action=this.upLoadUrl :before-upload='handleBefore' :data="exData" :on-success="handleSuccess" :on-error="handleError" ref="upload">
                <Button type="ghost" :loading='loading' icon="ios-cloud-upload-outline">{{$t('gscInt.import.upLoadFile')}}</Button><!--上传文件-->
            </Upload>
        </div>
        <div v-else-if="current === 2" class="step-container">
            <div class="form-item-tip">
                <h3 v-if="Object.prototype.toString.call(downInportResultObj.sourceToken)=== '[object Object]' || Object.prototype.toString.call(downInportResultObj.sourceToken)=== '[object Array]' ? (downInportResultObj.sourceToken && downInportResultObj.sourceToken.docId || downInportResultObj.sourceToken.errorMsg) : downInportResultObj.sourceToken">{{$t('gscInt.import.upLoadEndClick')}}<span style="cursor:pointer;color:red" @click="downInportResult">{{$t('gscInt.import.downLoad')}}</span>{{$t('gscInt.import.lookResult')}}</h3><!--导入结束，点击--> <!--下载--> <!--查看导入结果-->
            </div>
        </div>
        <div slot="footer">
            <m-button :loading='loading' v-if="notNeedDownLoadTempete?current > 1 : current > 0 && current < 2" @click="prev">{{$t('gscInt.import.prevStep')}}</m-button><!--上一步-->
            <m-button :loading='loading' v-if="current < 2" type="primary" @click="next">{{$t('gscInt.import.nextStep')}}</m-button><!--下一步-->
            <m-button v-else type="success" @click="handleComplete">{{$t('gscInt.import.complete')}}</m-button><!--完成-->
        </div>
    </Modal>
</template>
<script>
export default {
    name: "m-import",
    props: {
        exData: {
            type: Object,
            default() {
                return {}
            }
        },
        upLoadUrl: { //下载模板路径
            type: String
        },
        title: {
            type: String
        },
        showSuccessDeal:{
            type:Boolean,
            default:false
        },
        beforeSuccessDeal:{
            type:Boolean,
            default:false
        },
        loading:{
            type:Boolean,
            default:false
        },
        visible: {
            type:Boolean,
            default: false
        },
        notNeedDownLoadTempete: {
            type:Boolean,
            default: false
        },
    },
    data() {
        return {
            current: 0,
            downInportResultObj: {},
            show: this.visible
        }
    },
    watch: {
        visible: {
            handler(val) {
                this.show = val;
            }
        }
    },
    methods: {
        setCurrent(current){
            this.current = current
        },
        visableChange(val) {
            this.$emit('update:visible', val);
            this.$emit('visableChange', val);
        },
        // 上传前触发
        handleBefore(file){
            this.$emit('handleBefore',file);
        },
        /**下载模板 **/
        downloadTemplate: function() {
            this.$emit('downloadTemplate');
            // console.log('api.jobOrderImport:', api.jobOrderImport);
            // window.open(`/srmbase/supplierfile/downloadFile?docId=` + api.jobOrderImport);
        },
        handleSuccess(res, file) {
            if(this.beforeSuccessDeal){
                this.$emit('beforeSuccessDeal',res,file);
            }else {
                this.$emit('completeResult',res,file);//状态码为200时，返回的结果
                // if (res.data.status) {
                //     this.$Modal.error({
                //         content: res.data.msg
                //     });
                //     return;
                // }
                if (res.success) {
                    if (res.data.status === 500) {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: res.data.msg
                        });
                    } else {
                        this.downInportResultObj = {
                            fileName: file.name,
                            sourceToken: res.data.data
                        };
                        console.log(this.downInportResultObj);
                        this.current++;
                        var bar = document.querySelector('#step-bar-active');
                        bar.style.width = this.current * 125 + 'px';
                        if(!this.showSuccessDeal){
                            if(res.data.data.status === 'fail'){
                                this.$Modal.error({
                                    content: res.data.msg
                                });
                            }else{
                                this.current = 0;
                                let bar1 = document.querySelector('#step-bar-active');
                                bar1.style.width = 0 + 'px';
                                this.$Message.info(res.data.msg);
                                this.$emit('successfull', this.downInportResultObj);
                            }
                        }else{
                            this.$emit('successDeal',res,file);
                        }
                    }
                } else {
                    this.$refs['upload'].clearFiles();
                    let msg = '';
                    if (typeof(res.data) === 'undefined') {
                        msg = res.errorCode;
                    } else {
                        msg = res.data.msg;
                    }
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: msg
                    });
                }
            }
        },
        handleError() {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: this.$t('gscInt.import.tips2'), //'附件上传失败，请检查附件后重新上传！'
            });
            this.$emit('handleError');
        },
        downInportResult() {
            // window.open(`/gscapp/ImportReceipt/receipt?sourceToken=${this.downInportResultObj.sourceToken}&fileName=${this.downInportResultObj.fileName}`);
            this.$emit('downLoadResult', this.downInportResultObj);
        },
        handleComplete() {
            this.current = 0;
            var bar = document.querySelector('#step-bar-active');
            bar.style.width = 0 + 'px';
            this.$emit('complete', this.downInportResultObj);
        },
        prev() {
            this.current--;
            var bar = document.querySelector('#step-bar-active');
            bar.style.width = this.current * 125 + 'px';
        },
        next() {
            if (this.current < 1) {
                this.current++;
                var bar = document.querySelector('#step-bar-active');
                bar.style.width = this.current * 125 + 'px';
            }
        },
        handleCancel: function() {
            // this.current = 0;
            // var bar = document.querySelector('#step-bar-active');
            // bar.style.width = 0 + 'px';
            this.$emit('iModalClose');
        }
    }
}

</script>
<style lang="less" scoped="scoped">
.step-header {
    width: 310px;
    padding: 0 10px 0 30px;
    position: relative;
    // overflow: hidden;
    margin:auto;

    ul {
        padding: 0;
        width: 375px;
        float: left;
        position: relative;

        li {
            list-style-type: none;
            float: left;
            position: relative;
            width: 125px;

            &.active {
                span {
                    background: #2d8cf0;
                }

                p {
                    color: #333333;
                }
            }

            p {
                font-weight: bold;
                margin-top: 5px;
                font-size: 13px;
                color: #999999;
                float: left;
                position: relative;
                left: -50%;
                text-align: center;
                width: 129px;
            }

            span {
                position: relative;
                height: 20px;
                width: 20px;
                border-radius: 10px;
                background: #ccc;
                left: -10px;
                display: block;
            }
        }
    }
}

.step-bar {
    width: 250px;
    height: 13px;
    background: #ccc;
    position: absolute;
    border-radius: 12px;
    top: 4px;
    overflow: hidden;
}

.step-bar-active {
    width: 0px;
    height: 13px;
    background: #2d8cf0;
}


</style>
<style>

.inportAbcd .m-modal-body{
  padding: 10px 30px 20px 30px;

}
.inportAbcd .m-modal-footer {
    padding:  0px 30px 30px 30px;
    text-align: right;
}
</style>
